module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "d-flex justify-content-center align-items-center"
  }, [_c('div', [_c('h1', {
    staticClass: "fs-30"
  }, [_vm._v("404")]), _vm._v(" "), _vm._t("default", [_c('p', {
    staticClass: "fs-8"
  }, [_vm._v("Page not found ")])])], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ../~/vue-loader/lib/template-compiler?{"id":"data-v-1e8f5d8c"}!../~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Basic404.vue
// module id = 993
// module chunks = 0